import { useState } from 'react';

import { routes } from '~/components/app/appMainRoutes';

export type Search = {
  country?: string[];
  description?: string[];
  employees?: string[];
  industry?: string[];
  raised?: string[];
  tag?: string[];
  tech?: string[];
  type?: string[];
};

const useTargetMarket = () => {
  const [search, setSearch] = useState<Search | null>(null);
  const [modifiedNotSaved, setModifiedNotSaved] = useState(false);
  const [id, setId] = useState<string | null>(null);

  const newSetSearch = (search: Search | null) => {
    setSearch(search);
    setModifiedNotSaved(true);
  };

  const setTargetMarket = ({
    search,
    id,
  }: {
    search: Search | null;
    id: string | null;
  }) => {
    setSearch(search);
    setId(id);
    setModifiedNotSaved(false);

    const url = window.location.href;
    const params = (url.split('?')[1] || '')
      .split('&')
      .filter((param) => !param.startsWith('id='))
      .join('&');

    if (!id) {
      window.history.pushState({}, '', `${routes.targetMarkets}?${params}`);
    } else {
      window.history.pushState(
        {},
        '',
        `${routes.targetMarkets}?id=${id}&${params}`,
      );
    }
  };

  return {
    search,
    setSearch: newSetSearch,
    modifiedNotSaved,
    id,
    setTargetMarket,
  };
};

export { useTargetMarket };
